import React from 'react'
import { string, node, bool } from 'prop-types'
import Icon from 'common/components/icon'
import { getLogoNameByHomeUrl, getLogoLinkByHomeUrl } from 'services/utility'
import { GEORGE_URL } from 'services/utility/constants'
import logoWhite from '../../../assets/images/footer-logo.svg'
import logoGeorge from '../../../assets/images/george.svg'

const Logo = ({
  color, children, isGeorgeUser, homeUrl,
}) => {
  if (color !== 'white') {
    return (
      <a id="logo" href={isGeorgeUser ? GEORGE_URL : getLogoLinkByHomeUrl(homeUrl)}>
        <Icon name={getLogoNameByHomeUrl(homeUrl)} color="green" size="large" />
        {children}
      </a>
    )
  }
  return <img src={isGeorgeUser ? logoGeorge : logoWhite} alt={isGeorgeUser ? 'George' : 'ASDA'} />
}

Logo.propTypes = {
  color: string,
  children: node,
  isGeorgeUser: bool,
  homeUrl: string,
}

Logo.defaultProps = {
  color: '',
  children: null,
  homeUrl: '',
  isGeorgeUser: false,
}

export default Logo



// WEBPACK FOOTER //
// ./components/header/asda-com/Logo.js